/** Where a fresh sign-in lands when no deep link is waiting to be returned to. */
export const DEFAULT_POST_LOGIN_PATH = '/dashboard';
